// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tsyupkamueskzbiktqps.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRzeXVwa2FtdWVza3piaWt0cXBzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU0NTEyMjcsImV4cCI6MjA2MTAyNzIyN30.QMivrpAxpyeDIhSNAN_KNArrLnY2ArxLFNpYkJlDkmw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);